<template>
	<div v-if="featured && featured.id" id="featured-image" class="page-image">
		<WpImage 
			:key="featured.id"
			:image="featured"
			:size="size"
			background
			caption
			styledCaption
			cover
			/>
	</div>
</template>

<script>
import WpImage from '@/components/elements/WpImage'

import { mapGetters } from 'vuex';

export default {
	name: 'featured-image',
	props: {
		size: {
			type: String,
			default: 'medium'
		}
	},
    components: {
        WpImage,
	},
	computed: {
        ...mapGetters([
			'featuredImage',
			'isFrontPage',
			'currentPage'
		]),
		featured(){
			if(this.isFrontPage && this.currentPage && this.currentPage.acf && this.currentPage.acf.home_banner && this.currentPage.acf.home_banner.image) return this.currentPage.acf.home_banner.image
			if(this.featuredImage && this.featuredImage.id) return this.featuredImage
		}
	}
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";

</style>
